import { useState } from 'react';
import { Fade } from '@mui/material';

import AuthLayout from 'layouts/auth-layout';

import Banner from './components/banner';
import ResetPassword from './components/reset-password';
import SentResetActions from './components/sent-reset-actions';
import SentResetBanner from './components/sent-reset-banner';

const ResetPasswordPage = () => {
  const [linkSent, setLinkSent] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  return (
    <AuthLayout>
      <Fade in={true}>
        <div>
          {linkSent ? (
            <>
              <SentResetBanner userEmail={userEmail} /> <SentResetActions email={userEmail} />
            </>
          ) : (
            <>
              <Banner />
              <ResetPassword
                updateParent={(email: string) => {
                  setUserEmail(email);
                  setLinkSent(true);
                }}
              />
            </>
          )}
        </div>
      </Fade>
    </AuthLayout>
  );
};

export default ResetPasswordPage;
